import React, { useState, useEffect } from "react";
import "../CSS/TopbarTenagaKesehatan.css";
import { FaBell, FaUserCircle } from "react-icons/fa";

function TopbarDetail() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Ambil data user dari localStorage setelah login
    const storedUser = JSON.parse(localStorage.getItem("user")); 
    setUser(storedUser);
  }, []);

  return (
    <div className="topbar">
      <div className="topbar-left">
        <h2 className="page-title">Profile</h2>
      </div>

      {/* Render user-info hanya jika user ada */}
      {user && (
        <div className="user-info">
          <FaBell className="icon" />
          <div className="user-name">
            <p className="name">{user.username_tenagakesehatan || user.username || "Guest"}</p>
            <p className="role">{user.Profesi || user.profesi || "-"}</p>
          </div>
          <FaUserCircle className="profile-icon" />
        </div>
      )}
    </div>
  );
}

export default TopbarDetail;
